import React from 'react';
import { BRAND } from '../lib/butterstone';

const SplashScreen = ({ isReady }) => (
  <div className={`splash-screen ${isReady ? 'splash-fade-out' : ''}`}>
    <h1 className="splash-wordmark">Butterstone<br/>River Valley</h1>
    <p className="splash-tagline">{BRAND.tagline}</p>
    <div className="splash-loader">
      <span className="splash-loader-bar" /><span className="splash-loader-bar" /><span className="splash-loader-bar" /><span className="splash-loader-bar" /><span className="splash-loader-bar" />
    </div>
  </div>
);

export default SplashScreen;
